import SlideBase from "react-slick";
import styled from "@emotion/styled";
import { VStack } from "goi_common";
import SlideItem from "./SlideItem";
import { Box } from "@chakra-ui/react";

const initialSlide = 0;

/**
 * e하늘 공공데이터 이미지는 메타데이터가 없으므로
 * 장례식장 공간 키워드 + 지역명을 조합해 개별 alt를 생성한다.
 * 이미지 수가 키워드 풀보다 많으면 순환 + 번호 suffix로 중복을 방지한다.
 */
const SPACE_KEYWORDS = [
  "전경",
  "빈소(분향소)",
  "유족 대기실",
  "장례식장 내부",
  "식당 및 편의시설",
  "접수 로비",
  "주차장 및 외부",
  "추모 공간",
];

const getImageAlt = (name: string, index: number, total: number, region?: string) => {
  const regionSuffix = region ? ` - ${region}` : "";
  const keyword = SPACE_KEYWORDS[index % SPACE_KEYWORDS.length];
  const round = Math.floor(index / SPACE_KEYWORDS.length);
  const numberSuffix = round > 0 ? ` ${round + 1}` : "";

  return `${name} ${keyword}${numberSuffix}${regionSuffix}`;
};

const ImageSlideSection = ({
  images,
  name,
  height = "240px",
  padding = "0",
  region,
}: {
  images: Array<any>;
  name: string;
  height?: string;
  padding?: string;
  region?: string;
}) => {
  return (
    <VStack position="relative" padding={padding}>
      <Slide
        initialSlide={initialSlide}
        autoplay
        autoplaySpeed={5000}
        pauseOnDotsHover={false}
        pauseOnHover={false}
        pauseOnFocus={false}
      >
        {images.map((image, index) => {
          const { id, url } = image;
          const alt = getImageAlt(name, index, images.length, region);
          return <SlideItem height={height} key={id} src={url} name={alt} />;
        })}
      </Slide>

      {images.length === 0 && <Box height={240} />}
    </VStack>
  );
};

const Slide = styled(SlideBase)`
  position: relative;

  .slick-arrow {
    position: absolute;
    top: 109px;
    width: 14px;
    height: 25px;
    font-size: 0;
    z-index: 10;
  }

  .slick-prev {
    left: 20px;
    background-size: contain;
  }

  .slick-next {
    right: 20px;
    background-size: contain;
  }
`;

export default ImageSlideSection;
